import type { ActionFailure } from "@/server/action-error";

/**
 * guarded()로 감싼 서버 액션의 결과를 벗겨낸다. 실패 봉투면 클라이언트 쪽에서
 * 같은 메시지로 Error를 다시 던지므로, 호출부는 기존 try/catch를 그대로 쓰면 된다:
 *
 *   try { await run(createExpenseAction(tripId, input)); }
 *   catch (err) { toast.error(err instanceof Error ? err.message : "저장에 실패했습니다"); }
 *
 * guarded로 감싼 액션은 **반드시** 이걸 통과시켜야 한다. 반환값을 쓰지 않는
 * void 액션은 run을 빼먹어도 타입 오류가 나지 않아 오류를 조용히 삼키게 된다.
 */
export async function run<T>(promise: Promise<T | ActionFailure>): Promise<T> {
  const result = await promise;
  if (result !== null && typeof result === "object" && "__actionError" in result) {
    throw new Error((result as ActionFailure).__actionError);
  }
  return result as T;
}
